import { formatToGrs } from 'shared/time-utilites'
import { getRequestHeaders } from 'grs/api'
import { PromoCodeError, CreateReservationError } from 'basket/errors'
import { jsonPost } from 'api'
import { guestCheckoutReservationData, generateReservationList } from './dataMappers'

export const redeemPromoCode = (item, rawPromoCode, apiLanguageCode = 'EN', token) => {
    const {
        eDataLocationId: locationId,
        rateId,
        fromDate,
        toDate,
        actualFromDate,
        actualToDate,
        defaultCustomerFlow,
    } = item.rate

    const ReservationInfoData = {
        ACTUALFDATE: formatToGrs(actualFromDate),
        ACTUALTODATE: formatToGrs(actualToDate),
        LOC: locationId,
        RATEID: rateId,
        FD: formatToGrs(fromDate),
        TD: formatToGrs(toDate),
        PRMCODE: rawPromoCode,
        ISOLANGCODE: apiLanguageCode,
        CUSTOMERFLOWTYPE: defaultCustomerFlow,
    }

    if (token) {
        ReservationInfoData.TOKEN = token
    }
    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/RedeemPromoCode`,
        {
            ReservationInfoData,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new PromoCodeError(error.message)
    })
}

export const createReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
}) => {
    const payload = {
        ReservationInfoList: generateReservationList(
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            PIX
        ),
        Token: token,
        ISOLANGCODE: apiLanguageCode,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/CreateCartLoginReservationJSONPOST`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const createGuestUserReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    recaptchaToken,
    inboundNumber,
    outboundNumber,
    PIX,
}) => {
    const payload = guestCheckoutReservationData(
        token,
        items,
        userDetails,
        selectedVehicleDetails,
        apiLanguageCode,
        inboundNumber,
        outboundNumber,
        PIX,
        recaptchaToken
    )

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/CreateCartLoginReservationJSONPOST`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const editReservation = async ({
    token,
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    reservationId,
}) => {
    const payload = {
        ReservationInfoData: generateReservationList(
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            PIX,
            reservationId
        )[0],
        Token: token,
        ISOLANGCODE: apiLanguageCode,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/AmendCartReservationJSONPost`,
        {
            ...payload,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}

export const editGuestUserReservation = async ({
    items,
    userDetails,
    selectedVehicleDetails,
    apiLanguageCode = 'EN',
    card,
    boletoData,
    recaptchaToken,
    startedWithProductId,
    inboundNumber,
    outboundNumber,
    additionalServices,
    PIX,
    reservationId,
}) => {
    const payload = {
        ReservationInfoData: generateReservationList(
            items,
            userDetails,
            selectedVehicleDetails,
            apiLanguageCode,
            card,
            boletoData,
            startedWithProductId,
            inboundNumber,
            outboundNumber,
            additionalServices,
            PIX,
            reservationId
        )[0],
        ISOLANGCODE: apiLanguageCode,
        Is_EComm: true,
        'g-recaptcha-response': recaptchaToken,
    }

    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/GuestAmendCartReservationJSONPOST`,
        {
            ...payload,
            ISOLANGCODE: apiLanguageCode,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
}
